"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasProperty = void 0;
function hasProperty(entry, property) {
    if (entry === undefined || property === undefined)
        throw new Error('Missing argument: expects an object and string property key');
    return Object.prototype.hasOwnProperty.call(entry, property);
}
exports.hasProperty = hasProperty;
exports.default = {
    hasProperty: hasProperty,
};
//# sourceMappingURL=spyrjari.js.map